//* --------------------------------------------------*\
//    $SELECTORS - CSS selectors ONLY
// -  tag names, #ids, .classnames, [attributes], etc
//* --------------------------------------------------*/

const SELECTORS = {
  ALL: '#all',
  ANCHOR: 'a',
  ANCHOR_WITH_HREF: 'a[href]',
  API_RESULTS: '[data-loadcomponent="APIResults"]',
  APPLY_FILTERS_BUTTON: '#applyFiltersButton',
  BACKGROUND: '.background',
  BODY_TEXT: 'body-text',
  BUTTON: 'button',
  CARE_ALERT_BANNER_HIDDEN: 'care-alert-banner-hidden',
  CASE_REASON: '#case-reason',
  CARE_LIGHTBOX: 'care-lightbox',
  CHECKED: ':checked',
  CHECKED_LABEL: ':checked + label',
  CHECKBOX: 'checkbox',
  CIRCLE: 'circle',
  CLOSE: '.close',
  CLOSE_SEARCH: '.close-search',
  DATA_BOTTOM: 'data-bottomposition',
  DATA_FACET_NAME: 'data-facet-name',
  DATA_HALFWAY: 'data-halfway',
  DATA_HAS_ANIMATED: 'data-has-animated',
  DATA_HOVERIMG: 'data-hoverimg',
  DATA_ISO: 'data-iso',
  DATA_LAZY_LOAD: 'data-lazyload',
  DATA_MOUSEFOLLOW: '[data-mousefollow]',
  DATA_PCT: 'data-pct',
  DATA_POSITION: 'data-position',
  DATA_SLIDESHOW_CURRENT: 'data-slideshow-current',
  DATA_SLIDESHOW_DESCRIPTION: 'data-slideshow-description',
  DATA_SLIDESHOW_HEADLINE: 'data-slideshow-headline',
  DATA_SLIDESHOW_SLIDE: 'data-slideshow-slide',
  DATA_SLIDESHOW_TOTAL: 'data-slideshow-total',
  DATA_TARGET_PCT: 'data-target-pct',
  DATA_VALUE: 'data-value',
  DATA_VISIBLE: '[data-visible]',
  DATA_TARGET_PCTS: 'data-target-pcts',
  DATA_YT: 'data-yt',
  DESCRIPTION: '#description',
  DIV: 'div',
  DONATE_VALUE: '.donation-amount-button',
  DONATE_LEVEL: 'input[name="set.DonationLevel"]',
  DROPDOWN: '.dropdown',
  DROPDOWN_CONTENT: '.dropdown__content',
  DROPDOWN_TOGGLE: '.dropdown__toggle',
  DROPDOWN_TOGGLE_CLICK: '.dropdown.click',
  DROPDOWN_TOGGLE_HOVER: '.dropdown.hover',
  EMAIL: '.share--email',
  EMAIL_ID: '#email',
  EYE: '.eye',
  FACEBOOK: '.share--fb',
  FACETWP_FACET: 'facetwp-facet',
  FILE_INPUT: 'input[type=file]',
  FILTER: '.filter',
  FILTERS_BUTTON: '#filtersButton',
  FILTER_CHOICE: '.filter-choice',
  FILTER_FORM: '.filters-form',
  FILTER_OPTION: '.filter-option',
  FILTERS_POPUP: 'resource-filters__mobile-popup',
  FILTERS_POPUP_CLOSE: 'resource-filters__mobile-popup__close',
  FILTER_TRIGGER: '.filter-trigger',
  FORM: 'form',
  FORM_FIELDS: 'input, select, textarea',
  FOOTER: 'footer',
  FUN_FACT_ITEM: '.fun-fact__item',
  GEO_LOCATION_POPUP_SHOWN: 'geo-location-popup-shown',
  G_RECAPTCHA_RESPONSE: '#g-recaptcha-response',
  G_TOKEN: 'g-token',
  HTML: 'html',
  HOME_FORM_FIELDS: 'input, textarea, select, button',
  H2: 'h2',
  ID: 'id',
  INVALID: ':invalid',
  LAST_OF_TYPE: 'last-of-type',
  LIGHTBOX_VISIBLE: 'lightbox--visible',
  LINKEDIN: '.share--li',
  LOADING: '.loading',
  LOAD_MORE: '.load-more',
  MENU_TXT: '.menu-txt',
  MOUSEFOLLOW: '.mousefollow',
  NAV_TRIGGER: '.nav_trigger',
  NAME: '#name',
  NESTED: '.nested',
  NEXT_FACT: '.next-fact',
  OGDESC: 'meta[property="og:description"]',
  OGTITLE: 'meta[property="og:title"]',
  OGURL: 'meta[property="og:url"]',
  OPEN_SEARCH: '.open-search',
  OPTGROUP: 'optgroup',
  PARAGRAPH: 'p',
  PHONE: '#phone',
  POST_COUNT: '.post-count .count',
  POST_LISTING: '.post-listing',
  RADIO: '[type="radio"]',
  RADIUS: 'r',
  RESULTS_CONTAINER: '.results-container',
  SCRIPT: 'script',
  SECTION: 'section',
  SEARCH_INPUT: '.search-field__input',
  SELECTED: '.selected',
  SOURCE_PAGE_URL: '#Source_Page_URL',
  SOURCE_PAGE_URL_INPUT: 'input[name="Source_Page_URL"]',
  SPAN: 'span',
  STATISTIC_VALUE: '.statistic__value',
  STROKE_DASHARRAY: 'stroke-dasharray',
  SUBMISSION_RESPONSE: '.submission-response',
  SUBMIT: '[type="submit"]',
  SVG: 'svg',
  SVG_CIRCLE: 'svg circle:nth-of-type',
  SVG_CIRCLE_NTH_CHILD: 'svg circle:nth-child(2)',
  TAB: '[role="tab"]',
  TABPANEL: '[role="tabpanel"]',
  TOPIC: '#topic',
  TOPIC_MAPPING: '#topicMapping',
  TYPE: '#type',
  TOOLTIP: 'tooltip',
  TWITTER: '.share--tw',
  UL: 'ul'
};

export default SELECTORS;
